import request from './request'
import {
    addUserReq, changeUserReq, createScanQrReq, createTransQrReq, deleteUserReq,
    DeveloperInfoReq,
    IndexStatReq, MerchantInfoReq, modifyFeeTypeReq, modifyMarkUpRateReq, orderDetailReq, orderListReq, refundReq,
    SettlementListReq, storeListReq,
    userListReq, baseReq, modifyPassReq, signkeyReq, resetPassReq,accountReq,cashReq,linkCreateReq,linkSearchReq,
	CurrencyReq, ExchangeReq, ExchangeRecordsReq
} from "./types";
import request_file from "./request_file";


export default class API {
    static login = (params: any) => {
        return request('/app/user/login', params)
    }
    static storeList = (params: any) => {
        return request('/app/store/list', params)
    }
    static getMerchantInfo = (params: MerchantInfoReq) => {
        return request('/app/user/merchantInfo', params)
    }
    static getInexState = (params: IndexStatReq) => {
        return request('/app/query/indexCount', params)
    }
    static getOrderList = (params: orderListReq) => {
        if(params.exportFlag){
            return request_file('/app/query/bill', params)
        }else{
            return request('/app/query/bill', params)
        }
    }
    static getStoreList = (params: storeListReq) => {
        return request('/app/store/list', params)
    }
    static getUserList = (params: userListReq) => {
        return request('/app/user/list', params)
    }
    static getSettlementList = (params: SettlementListReq) => {
        if(params.exportFlag){
            return request_file('/app/query/settlement', params)
        }else {
            return request('/app/query/settlement', params)
        }
    }
    static modifyFeeType = (params: modifyFeeTypeReq) => {
        return request('/app/user/modifyFee', params)
    }
    static modifyMarkupRate = (params: modifyMarkUpRateReq) => {
        return request('/app/user/modifyMarkupRate', params)
    }
    static getDeveloperInfo = (params: DeveloperInfoReq) => {
        return request('/app/user/devInfo', params)
    }
    static addUser = (params: addUserReq) => {
        return request('/app/user/add', params)
    }
    static deleteUser = (params: deleteUserReq) => {
        return request('/app/user/del', params)
    }
    static modifyUser = (params: changeUserReq) => {
        return request('/app/user/modify', params)
    }
    static getOrderDetail = (params: orderDetailReq) => {
        return request('/app/query/single', params)
    }
    static refund = (params: refundReq) => {
        return request('/app/trade/refund', params)
    }
    static createTransQr = (params: createTransQrReq) =>{
        return request('/app/trade/create', params)

    }
    static createScanQr = (params: createScanQrReq) =>{
        return request('/app/trade/scan', params)
    }
    static logout = (params: baseReq) => {
        return request('/app/user/logout', params)
    }
    static modifyPassword = (params: modifyPassReq) => {
        return request('/app/user/modifyPwd', params)
    }
    static getSignKey = (params: signkeyReq) => {
        return request('/app/user/signKey', params)
    }
    static forgotPassword = (params: baseReq) => {
        return request('/app/user/findPassword', params)
    }
    static resetPassword = (params: resetPassReq) => {
        return request('/app/user/resetPassword', params)
    }
    static checkIsLogin = (params: baseReq) => {
        return request('/app/user/checkLogined', params)
    }
    static getAccount = (params: accountReq) => {
        return request('/app/user/merchantAccount', params)
    }
    static cashMoney = (params: cashReq) => {
        return request('/app/trade/withdraw', params)
    }
	static linkCreate = (params: linkCreateReq) => {
	    return request('/app/trade/receiptLink', params)
	}
	static linkSearch = (params: linkSearchReq) => {
	    return request('/app/query/queryReceiptLink', params)
	}
	static getCurreny = (params: CurrencyReq) => {
	    return request('/app/query/queryExchangeRate', params)
	}
	static submitExchange = (params: ExchangeReq) => {
	    return request('/app/trade/exchange', params)
	}
	static getExchangeRecords = (params: ExchangeRecordsReq) => {
	    return request('/app/query/queryExchangeOrder', params)
	}
}